<template>
  <main class="main-content main-content-bg mt-0">
    <div class="page-header min-vh-95">
      <span class="mask bg-gradient-dark opacity-6"></span>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-7 mt-2">
            <div class="card border-0 mb-0">
              <div class="card-header bg-transparent text-center pb-0">
                <img
                  :src="
                    layout === 'landing' || darkMode || sidebarType === 'bg-default'
                      ? logoWhite
                      : logo
                  "
                  class="navbar-brand-img img-fluid "
                  style="max-height: 100px; max-width: 50%;"
                  alt="main_logo"
                />
              </div>
              <div class="card-header text-center pt-2 pb-3">
                <h6 class="text md mb-0">Inicie sesión con</h6>
              </div>
              <div class="card-body px-lg-5 pt-0">
                <!--
                <div class="col-12 ms-auto px-1 ">
                  <a class="btn btn-outline-light w-100" href="javascript:;">
                    <svg width="24px" height="32px" viewBox="0 0 64 64" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(3.000000, 2.000000)" fill-rule="nonzero">
                          <path
                            d="M57.8123233,30.1515267 C57.8123233,27.7263183 57.6155321,25.9565533 57.1896408,24.1212666 L29.4960833,24.1212666 L29.4960833,35.0674653 L45.7515771,35.0674653 C45.4239683,37.7877475 43.6542033,41.8844383 39.7213169,44.6372555 L39.6661883,45.0037254 L48.4223791,51.7870338 L49.0290201,51.8475849 C54.6004021,46.7020943 57.8123233,39.1313952 57.8123233,30.1515267"
                            fill="#4285F4" />
                          <path
                            d="M29.4960833,58.9921667 C37.4599129,58.9921667 44.1456164,56.3701671 49.0290201,51.8475849 L39.7213169,44.6372555 C37.2305867,46.3742596 33.887622,47.5868638 29.4960833,47.5868638 C21.6960582,47.5868638 15.0758763,42.4415991 12.7159637,35.3297782 L12.3700541,35.3591501 L3.26524241,42.4054492 L3.14617358,42.736447 C7.9965904,52.3717589 17.959737,58.9921667 29.4960833,58.9921667"
                            fill="#34A853" />
                          <path
                            d="M12.7159637,35.3297782 C12.0932812,33.4944915 11.7329116,31.5279353 11.7329116,29.4960833 C11.7329116,27.4640054 12.0932812,25.4976752 12.6832029,23.6623884 L12.6667095,23.2715173 L3.44779955,16.1120237 L3.14617358,16.2554937 C1.14708246,20.2539019 0,24.7439491 0,29.4960833 C0,34.2482175 1.14708246,38.7380388 3.14617358,42.736447 L12.7159637,35.3297782"
                            fill="#FBBC05" />
                          <path
                            d="M29.4960833,11.4050769 C35.0347044,11.4050769 38.7707997,13.7975244 40.9011602,15.7968415 L49.2255853,7.66898166 C44.1130815,2.91684746 37.4599129,0 29.4960833,0 C17.959737,0 7.9965904,6.62018183 3.14617358,16.2554937 L12.6832029,23.6623884 C15.0758763,16.5505675 21.6960582,11.4050769 29.4960833,11.4050769"
                            fill="#EB4335" />
                        </g>
                      </g>
                    </svg>
                  </a>
                </div>

                <div class="mt-2 mb-4 position-relative text-center">
                  <p class="text-sm font-weight-bold mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3">
                    o
                  </p>
                </div> -->
                <form class="text-start" @submit.prevent="handleSubmit">
                  <div class="mb-3 ">
                    <argon-input
                      id="email"
                      v-model="email"
                      full-width 
                      type="email"
                      placeholder="Correo Electronico"
                      aria-label="Email"
                      required
                    />
                  </div>
                  <div class="mb-3 position-relative">
                    <argon-input
                      id="password"
                      v-model="password"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="Contraseña"
                      aria-label="Password"
                      required
                    />
                    <span
                      class="toggle-password"
                      @click="showPassword = !showPassword"
                    >
                    <i :class="showPassword ? 'fas fa-eye-slash bg-white' : 'far fa-eye bg-white'"></i>
                    </span>
                  </div>

                  <div v-if="errors.length" class="error-messages text-danger">
                    <ul>
                      <li v-for="(error, index) in errors" :key="index">
                        {{ error }}
                      </li>
                    </ul>
                  </div>

                  <div class="mb-2 position-relative">
                    <router-link :to="{ name: 'Recover Password'}" class="text-sm font-weight-bold">
                      ¿Olvidaste tu contraseña?
                    </router-link>
                  </div>

                  <div class="text-center">
                    <argon-button 
                      color="dark" 
                      full-width 
                      class="my-4 mb-2"
                      :disabled="loading"
                    >
                      {{ loading ? "Procesando..." : "Iniciar Sesión" }}
                    </argon-button>
                    <router-link
                    
                        :to="{ name: 'Register' }"
                        class="text-dark w-100 font-weight-bolder btn btn-light"
                      >
                        Registrarse
                      </router-link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex"; // Import useStore

import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import logo from "@/assets/AppLogoFull.png";
import SignIn from "./domain/sign-in"; 

import { validateEmail } from "@/utilities/common";
import { setToken } from "@/utilities/storage";
import generateUserProfile from "@/views/auth/domain/generate-user-profile"; 

const email = ref("");
const password = ref("");
const errors = ref([]);
const showPassword = ref(false);
const router = useRouter();
const loading = ref(false);
const store = useStore(); // Get store instance

onMounted(() => {
  store.commit('setShowSidenav', false);
});

const handleSubmit = async () => {
  errors.value = [];
  loading.value = true;

  // Validate email and password
  if (!validateEmail(email.value)) {
    errors.value.push("Por favor, introduce un correo válido.");
  }
  if (password.value.length < 6) {
    errors.value.push("La contraseña debe tener al menos 6 caracteres.");
  }

  if (errors.value.length) {
    loading.value = false;
    return;
  }

  try {
    const response = await SignIn(email.value, password.value);
    const { token } = response;
    setToken(token);

    // Fetch user profile before storing
    const userProfile = await fetchPerfilUsuario(token);

    // Prepare user data for store
    const userData = {
      firstName: userProfile.nombre?.split(' ')[0] || 'Usuario',
      lastName: userProfile.nombre?.split(' ')[1] || '',
      fullName: userProfile.nombre || '',
      email: userProfile.email || email.value,
      roleId: userProfile.role_id // Make sure this matches your role system
    };

    // Use store dispatch instead of direct sessionStorage
    await store.dispatch('login', {
      userData,
      token
    });

    // Redirect based on role
    switch (parseInt(userProfile.role_id)) { // Changed from userProfile.rol to userProfile.role_id
      case 1: // Owner
      case 2: // Admin
        store.commit('setShowSidenav', true);
        router.push({ name: "Usuarios" });
        break;
      case 3: // Instructor
        store.commit('setShowSidenav', true);
        router.push({ name: "Tabla Cursos" });
        break;
      case 4: // Student
        store.commit('setShowSidenav', true);
        router.push({ name: "Mis Cursos" });
        break;
      default: // Guest
        router.push({ name: "Explorar Cursos" });
    }

  } catch (error) {
    if (error.message.includes("401")) {
      errors.value.push('Credenciales incorrectas');
    } else {
      errors.value.push('Error al conectar con el servidor: ' + error.message);
    }    
  } finally {
    loading.value = false;
  }
};

const fetchPerfilUsuario = async (token) => {
  try {
    const data = await generateUserProfile(token);
    return data;
  } catch (err) {
    console.error("Error fetching user profile:", err);
    throw err;
  }
};
</script>
<style scoped>
.error-messages {
  margin-bottom: 1rem;
  color: red;
}

.page-header {
  background-image: url('@/assets/img/login-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.toggle-password {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 1.2rem;
  color: #6c757d;
}
</style>
